import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize } from '../../theme';

const NoteStyled = styled.span`
    font-family: ${fontFamilyPrimary};
    font-size: ${fontSize.s};
    color: ${colors.grey400};
    margin-top: 8px;
    display: block;
`;

const RequiredFieldsNote: FC = () => {
    const { t } = useTranslation('settings');

    return <NoteStyled>{t('form.requiredFields')}</NoteStyled>;
};

export default RequiredFieldsNote;
